import { render, staticRenderFns } from "./BuyerAnalyticsView.vue?vue&type=template&id=30bc5319&"
import script from "./BuyerAnalyticsView.vue?vue&type=script&lang=ts&"
export * from "./BuyerAnalyticsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
